import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import ComplianceUploadUI from 'components/ComplianceUploadUI';
import { Link } from 'react-router-dom';

const ComplianceSelection = ({
  response,
  fileData,
  handleUploadComplianceDoc,
  setFileData,
  isUploading,
}) => {
  return (
    <div>
      {response === 200 ? (
        <Button variant='text' sx={{ textTransform: 'unset' }}>
          <Link
            style={{ textDecoration: 'none', color: 'unset' }}
            to={'/settings'}
          >
            See compliance status
          </Link>
        </Button>
      ) : (
        <ComplianceUploadUI
          fileData={fileData}
          handleSubmit={handleUploadComplianceDoc}
          setFileData={setFileData}
          isUploading={isUploading}
        />
      )}
    </div>
  );
};

ComplianceSelection.propTypes = {
  response: PropTypes.number.isRequired,
  fileData: PropTypes.object.isRequired,
  handleUploadComplianceDoc: PropTypes.func.isRequired,
  setFileData: PropTypes.func.isRequired,
  isUploading: PropTypes.bool.isRequired,
};

export default ComplianceSelection;
